import React, { useContext } from 'react'
import { Text, View } from 'oio-react'
import EventDetailsBlock from 'src/apps/Events/components/DetailsBlock'
import MessageFeed from 'src/apps/Messages/components/Feed'
import RichText from 'src/components/utils/RichText'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'
import ThemeContext from 'src/libraries/contexts/Theme'
import InitiativeDetailsBlock from '~/components/DetailsBlock'

const InitiativeViewHome = () => {
   const theme = useContext(ThemeContext)
   const { initiative } = useContext(InitiativeHierarchyContext)
   const initiativeBody = initiative?.body?.elements?.[0]?.body

   return (
      <>
         {initiativeBody && (
            <View
               float="left"
               width="100%"
               paddingTop="40px[a-d] 80px[e-f]"
               paddingBottom="30px"
               opacity="0.6">
               <Text
                  size={theme.tmpBodyTextSize}
                  lineHeight={theme.tmpBodyTextLineHeight}
                  color={theme.tmpContentTextColor}>
                  <RichText html={initiativeBody} />
               </Text>
            </View>
         )}
         <View paddingBottom="30px">
            {initiative.class === 'event' && (
               <EventDetailsBlock />
            )}
            {initiative.class !== 'event' && (
               <InitiativeDetailsBlock />
            )}
         </View>
         {initiative.appsMessagesEnabled && (
            <MessageFeed
               currentUserCanModerate={initiative.currentUserCanModerate}
               displayMode="feed"
               hasUnreadEntries={initiative.thread.hasUnreadEntries}
               messageLastViewed={initiative.thread.messageLastViewed}
            />
         )}
      </>
   )
}

export default InitiativeViewHome
